export class ChargingStationByGroupDto {
  id: string;
  name: string;
  customerId: number;
  groupId: number;
  groupName: string;
  allGroupsId: number[];

  getPrimaryKey() {
    return this.id;
  }
}
